<div class="n-bg">
  <object class="n-logo" data="assets/icons/nomoh_logo.svg" type="image/svg+xml"></object>
  <div class="n-content">
    <div class="n-404">
      <p>4</p>
      <svg class="n-dot" width="50" height="50">
        <circle cx="25" cy="25" r="7" fill="#00" />
      </svg>
      <p>0</p>
      <svg class="n-dot" width="50" height="50">
        <circle cx="25" cy="25" r="7" fill="#00" />
      </svg>
      <p>4</p>
    </div>
    <div class="n-text">
      <h2 class="n-display-large">{{ 'PAGINA_NAO_ENCONTRADA.TITULO' | translate }}</h2>
      <p class="n-body-large">{{ 'PAGINA_NAO_ENCONTRADA.MENSAGEM' | translate }}</p>
    </div>
    <p-button [label]="'PAGINA_NAO_ENCONTRADA.BOTAO_VOLTAR' | translate" icon="pi pi-arrow-left"
      routerLink="/dashboard" />
  </div>
</div>
